import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useReducer } from 'react';
import { useId } from '../../hooks';
import { CLOSE_MENU, GO_TO_ITEM, GO_TO_NEXT_ITEM, GO_TO_PREV_ITEM, OPEN_MENU, REGISTER_ITEM, SET_NAVIGATING_WITH_KEYBOARD, UNREGISTER_ITEM } from './constants';
export var States;
(function (States) {
    States[States["Closed"] = 0] = "Closed";
    States[States["Open"] = 1] = "Open";
})(States || (States = {}));
const initialState = {
    id: '',
    state: States.Closed,
    activeItemIndex: -1,
    items: [],
    isNavigatingWithKeyboard: true
};
const getItemId = (dropdownId, itemId) => {
    return `dropdown-${dropdownId}-item-${itemId}`;
};
const getItemsId = (dropdownId) => {
    return `dropdown-${dropdownId}-items`;
};
const getNextIndex = (currentIndex, items) => {
    return (currentIndex + 1) % items.length;
};
const getPrevIndex = (currentIndex, items) => {
    return (currentIndex - 1 + items.length) % items.length;
};
const reducer = (state, action) => {
    switch (action.type) {
        case OPEN_MENU: {
            if (state.state === States.Open) {
                return state;
            }
            return { ...state, state: States.Open };
        }
        case CLOSE_MENU: {
            if (state.state === States.Closed) {
                return state;
            }
            return {
                ...state,
                state: States.Closed,
                activeItemIndex: -1,
                isNavigatingWithKeyboard: false
            };
        }
        case GO_TO_NEXT_ITEM: {
            const nextIndex = getNextIndex(state.activeItemIndex, state.items);
            return {
                ...state,
                activeItemIndex: state.activeItemIndex === -1 ? 0 : nextIndex,
                isNavigatingWithKeyboard: true
            };
        }
        case GO_TO_PREV_ITEM: {
            const prevIndex = getPrevIndex(state.activeItemIndex, state.items);
            return {
                ...state,
                activeItemIndex: state.activeItemIndex === -1 ? state.items.length - 1 : prevIndex,
                isNavigatingWithKeyboard: true
            };
        }
        case GO_TO_ITEM: {
            return { ...state, activeItemIndex: action.index };
        }
        case REGISTER_ITEM: {
            return {
                ...state,
                items: [...state.items, { id: action.id, element: action.element }]
            };
        }
        case UNREGISTER_ITEM: {
            return {
                ...state,
                items: state.items.filter(item => item.id !== action.id)
            };
        }
        case SET_NAVIGATING_WITH_KEYBOARD: {
            if (action.value === state.isNavigatingWithKeyboard) {
                return state;
            }
            return { ...state, isNavigatingWithKeyboard: action.value };
        }
        default:
            return state;
    }
};
const Context = createContext(undefined);
export const Provider = ({ children, id: customId, isOpen = false }) => {
    const id = useId(customId);
    const [state, dispatch] = useReducer(reducer, {
        ...initialState,
        id,
        state: isOpen ? States.Open : States.Closed
    });
    const memoizedGetItemId = useMemo(() => (itemId) => getItemId(id, itemId), [id]);
    const memoizedGetItemsId = useMemo(() => () => getItemsId(id), [id]);
    return (_jsx(Context.Provider, { value: {
            ...state,
            dispatch,
            id,
            getItemId: memoizedGetItemId,
            getItemsId: memoizedGetItemsId
        }, children: children }));
};
export const useDropdown = () => {
    const context = useContext(Context);
    if (!context) {
        throw new Error('useDropdown must be used within a Provider');
    }
    return context;
};
//# sourceMappingURL=Context.js.map